// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__K_W7F","paramInput":"JobSimulator_paramInput__1Cs8N","input":"JobSimulator_input__2Sazy"};